module.exports = __webpack_public_path__ + "static/media/pec.47be246c.md";